import { render, staticRenderFns } from "./WarpRealityModal.vue?vue&type=template&id=4bc01917&"
import script from "./WarpRealityModal.vue?vue&type=script&lang=js&"
export * from "./WarpRealityModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports